export default __webpack_public_path__ + "upload-yellow-icon.svg";